export const GettingReady = () => {
    return (
        <div className="c-alert u-pos-fixed u-pos-top-full u-fill-pos">
            Getting things ready
        </div>
    );
};
